export const isAppleDevice = () => {
    if (typeof window === 'undefined' || !window.navigator) {
        return false;
    }
    const userAgent = window.navigator.userAgent.toLowerCase();
    const platform = window.navigator.platform?.toLowerCase() || '';
    const isIOS = /iphone|ipad|ipod/.test(userAgent) ||
        (platform === 'macintel' && navigator.maxTouchPoints > 1);
    const isMac = /macintosh|mac os x/.test(userAgent) || platform.includes('mac');
    return isIOS || isMac;
};
export const isFirefox = () => {
    if (typeof window === 'undefined' || !window.navigator) {
        return false;
    }
    const userAgent = window.navigator.userAgent.toLowerCase();
    return /firefox|fxios/.test(userAgent);
};
//# sourceMappingURL=deviceDetection.js.map